import { useRef } from 'react';

export default function useAudio() {
  const sounds = useRef({
    // DOUBLE CHECK THESE NAMES:
    startGame: new Audio('/assets/audio/Start_Game.mp3'), 
    cardShuffle: new Audio('/assets/audio/Card_Shuffle.mp3'),
    yourTurn: new Audio('/assets/audio/Your_Turn.mp3'),
    trumpReveal: new Audio('/assets/audio/Trump_Reveal.mp3'),
    cardPlay: new Audio('/assets/audio/Card_Play.mp3'),
    diceRoll: (() => {
      const a = new Audio('/assets/audio/Dice_roll.mp3');
      a.volume = 0.8;
      return a;
    })(),
  });

  const playSound = (name) => {
    const audio = sounds.current[name];
    
    if (audio) {
      console.log(`🔈 Playing: ${name}`);
      audio.currentTime = 0;
      audio.play().catch(e => console.error(`❌ Audio blocked:`, e));
    } else {
      // THIS IS THE SMOKING GUN:
      console.error(`🚨 ERROR: Sound key "${name}" does not exist in UseAudio registry!`);
      console.log("Check your spelling. Available keys are:", Object.keys(sounds.current));
    }
  };

  return { playSound };
}